import { SignTitle } from '@/components'
import { Message } from '@/components/message'
import { useDebounce } from 'ahooks'
import { Button, Checkbox, Form, Input, message, Modal } from 'antd'
import { useEffect, useState } from 'react'
import Scrollbars from 'react-custom-scrollbars'
import styled from 'styled-components'
import { useBatchGroupCopy, useGetGroupAll, useGetTotal } from '../target/utils'
import { t } from '@/i18n'
const { useForm } = Form
export const Custom = props => {
  const { custom, cancel } = props
  const [form] = useForm()
  const [filterGroupName, setFilterGroupName] = useState('')
  const [getTotal, total] = useGetTotal()
  const debounceFilterGroupName = useDebounce(filterGroupName, { wait: 500 })
  const [getGroupAll, getGroupAllList] = useGetGroupAll()
  const [batchGroupCopy, batchGroupCopyloading] = useBatchGroupCopy()
  const [selectedList, setSelectedList] = useState()
  useEffect(() => {
    if (custom.visible) {
      getTotal()
        .then(res => {
          if ((custom?.ids?.length || 0) + res?.data?.total > 100000) {
            Message.error(t('超出数量限制，无法添加'))
          }
        })
        .catch(_ => {})
    }
  }, [custom])
  const onFinish = async (values: any) => {
    try {
      if (!selectedList) {
        Message.error(t('请选择部门'))
        return
      }
      await batchGroupCopy({
        ids: custom?.ids,
        group_id: selectedList,
      })
      cancel(true)
      setSelectedList(null)
    } catch (error) {}
  }
  useEffect(() => {
    getGroupAllList({ name: debounceFilterGroupName }).catch(_ => {})
  }, [debounceFilterGroupName])
  return (
    <ModalItem
      onOk={() => {
        form.submit()
      }}
      onCancel={() => {
        form?.resetFields()
        setFilterGroupName('')
        setSelectedList(null)
        cancel(false)
      }}
      title={<SignTitle show>{t('添加到')}</SignTitle>}
      destroyOnClose
      centered
      visible={custom?.visible}
      footer={
        <div style={{ display: 'flex', paddingLeft: '16px', justifyContent: 'flex-end' }}>
          <div style={{ display: 'flex', marginLeft: 16 }}>
            <Button
              onClick={() => {
                form?.resetFields()
                setFilterGroupName('')
                setSelectedList(null)
                cancel(false)
              }}
            >
              {t('取消')}
            </Button>
            <Button
              onClick={() => form.submit()}
              type="primary"
              disabled={(custom?.ids?.length || 0) + total?.total > 100000}
            >
              {t('确定')}
            </Button>
          </div>
        </div>
      }
    >
      <div style={{ paddingTop: 16 }}>
        <Form onFinish={onFinish} form={form}>
          <Input
            placeholder={t('请输入部门')}
            onChange={e => setFilterGroupName(e.target.value)}
            style={{ marginBottom: 16 }}
          />

          <Scrollbars className="list">
            {getGroupAll?.map(
              item =>
                item?.update_time && (
                  <ListItem className="list-item" key={item?.id}>
                    <Checkbox
                      checked={selectedList === item?.id}
                      onChange={e => {
                        if (e.target.checked) {
                          setSelectedList(item?.id)
                        } else {
                          setSelectedList(null)
                        }
                      }}
                    >
                      <div className="text">{item.name}</div>
                    </Checkbox>
                  </ListItem>
                ),
            )}
          </Scrollbars>
        </Form>
      </div>
    </ModalItem>
  )
}
const ModalItem = styled(Modal)`
  .list {
    height: 400px !important;
    border: 1px solid rgb(217, 217, 217);
    border-radius: 4px;
    margin-bottom: 16px;
  }
  .select-all {
    margin: 16px 0 10px;
  }
  .ant-modal-body {
    padding: 0 40px;
  }
  .ant-form-item-label {
    width: 100%;
    text-align: left;
  }
  .ant-form-horizontal .ant-form-item-control {
    flex: unset !important;
  }
  .ant-form-item-control {
    width: 100%;
  }
`
interface ListProps {
  isActive: boolean
}
const ListItem = styled.div<ListProps>`
  width: 393px;
  display: flex;
  justify-content: space-between;
  background: #f7f7f7;
  border-radius: 6px;
  cursor: pointer;
  padding: 8px 16px;
  margin-bottom: 8px;
  margin-left: 12px;
  transition: all 0.3s;
  &:nth-child(1) {
    margin-top: 16px;
  }
  p {
    margin: 0;
  }
  .text {
    max-width: 250px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 1.2;
  }
  .text-type {
    height: 16px;
    background: #ffffff;
    border-radius: 4px;
    color: #666666;
    line-height: 15px;
    font-size: 10px;
    padding: 0 4px;
  }
  &:hover {
    background: #e7e9f3;
  }
`
